import { defineStore } from 'pinia';
import { loginBUserDetail } from '@/api/common';

interface State {
  // 加载状态 0未加载; 1加载中; 2已加载
  loadStatus: number;
  user?: ApiCommon.UserInfoDTO;
}

// 权限相关 store
const useLoginUserDetailStore = defineStore('loginUserDetailStore', {
  state: (): State => ({
    loadStatus: 0,
    user: undefined
  }),
  getters: {
    userName(): string {
      return this.user?.userName ?? '';
    }
  },
  actions: {
    async tryLoadUserDetail() {
      if (this.loadStatus === 0 && this.loadStatus === 0) {
        await this.loadUserDetail();
      }
    },
    async loadUserDetail() {
      try {
        this.loadStatus = 1;
        const data = await loginBUserDetail();
        this.user = data.data.userInfoDTO;
        this.loadStatus = 2;
      } catch (e: any) {
        console.log(e);
        this.loadStatus = 0;
      }
    }
  }
});

export { useLoginUserDetailStore };
